import {Component, HostListener, Inject, OnDestroy, OnInit, ViewChild} from '@angular/core';

import {MAT_DIALOG_DATA, MatDialog} from '@angular/material/dialog';
import {COMMA, ENTER, TAB} from '@angular/cdk/keycodes';

import {Contact, Device, Group, GroupType, Individual, Pageable} from 'src/app/models';
import {DataService, DevicesService, GroupsService, GroupTypeService, IndividualsService, SnackbarService} from 'src/app/services';
import {CountryCodeComponent} from 'src/app/components';
import {stringCompare} from '../../utilities/string';

@Component({
    selector: 'app-chip-popup',
    templateUrl: './chip-popup.component.html',
    styleUrls: ['./chip-popup.component.scss']
})
export class ChipPopupComponent implements OnInit, OnDestroy {
    currentUserInfo: any;
    isAdmin: boolean;
    currentUser: any;
    loaded = false;
    groupReady = true;
    object: any;
    readonly SMS = 'SMS';
    readonly VOICE = 'VOICE';
    readonly EMAIL = 'EMAIL';
    readonly CHAT = 'CHAT';

    userProfile = true;
    isHaveIndividualInfo: any;
    userAuth = '';

    error = false;
    pageNum = 1;
    associateNames = null;
    associateNamesFormatted: string[] = [];
    isMobileResolution: boolean;
    // owners and membership
    selectable = false;
    removable = false;
    contacts: Contact[];
    @ViewChild('countryCode') countryCode: CountryCodeComponent;

    groupTypes: GroupType[] = [];
    separatorKeysCodes: number[] = [ENTER, COMMA, TAB];
    notification_to;
    filter = '';

    typeOf: any;

    disabled = false;
    buttonsDisabled = false;

    displayAddress = '';
    members: any;

    responseRequiredContacts: Contact[];
    responseRequiredAndInfoContacts: Contact[];
    informationalContacts: Contact[];
    silencedContacts: Contact[];
    messageTypesEnabled = false;

    constructor(private dataService: DataService,
                private snackbarService: SnackbarService,
                private groupTypeService: GroupTypeService,
                private dialog: MatDialog,
                private individualsService: IndividualsService,
                private groupsService: GroupsService,
                public deviceService: DevicesService,
                @Inject(MAT_DIALOG_DATA) public data: any) {
        this.object = this.data.object;
        this.typeOf = this.data.type;
    }

    ngOnInit() {
        this.dataService.getSetting("FF_MessageType").subscribe({
            next: res => {
                this.messageTypesEnabled = (res as boolean);
            }
        });
        if (this.typeOf === 'DEVICE') {
            this.deviceService.getMembership(this.object.id).subscribe(members => this.members = members);
        } else if (this.typeOf === 'GROUP') {
            this.groupsService.getMembership(this.object.id).subscribe(members => this.members = members.length >= 1 ? members : undefined);
        }
        this.dataService.getUserInfo().subscribe(res => {
            this.currentUserInfo = res;
            this.isAdmin = this.currentUserInfo.isAdmin;
            this.dataService.getIndividualAndAssociateExactMatchLookup(this.currentUserInfo['email']).subscribe({
                next: resi => this.currentUser = resi.content[0] || null,
                error: () => this.currentUser = null
            }).add(() => this.loaded = true);
            if (this.typeOf === 'GROUP') {
                this.groupReady = false;
                this.groupTypeService.getGroupTypes().subscribe((gTypes: GroupType[]) => {
                    this.groupTypes = gTypes;
                    if (this.object.notification_to_id != undefined) {
                        switch (this.object.notification_to_type) {
                            case 'DEVICE' :
                                this.deviceService.getDevice(parseInt(this.object.notification_to_id)).subscribe(device => this.notification_to = device.name);
                                break;
                            case 'GROUP' :
                                this.groupsService.getGroup(parseInt(this.object.notification_to_id)).subscribe(group => this.notification_to = group.name);
                                break;
                            case 'INDIVIDUAL' :
                                this.individualsService.getIndividual(parseInt(this.object.notification_to_id)).subscribe(individual => this.notification_to = individual.full_name);
                                break;
                            case undefined:
                                break;
                            default:
                                this.snackbarService.openSnackBar('Error parsing notify to, invalid notification to type.  Please set notification to and try again.');
                        }
                    }
                    this.groupReady = true;
                });
            }
            if (this.typeOf === 'INDIVIDUAL') {
                if (this.userProfile) {
                    this.isHaveIndividualInfo = true;
                    this.dataService.getUserInfo().subscribe(user => {
                        const res2 = user['authorities'];
                        if (res2.length) {
                            this.userAuth = res2[0].authority;
                        }
                    });
                    if (this.object.group_ownership !== undefined) {
                        this.object.group_ownership = this.object.group_ownership.sort((n1, n2) => {
                            return stringCompare(n1.name, n2.name);
                        });
                    }
                    this.updateContactMessageTypesChips(this.object.contacts);
                } else {
                    this.isHaveIndividualInfo = false;
                }
            }

        });
        this.showTopMostPopupOnly();
    }

    ngOnDestroy() {
        this.showTopMostPopupOnly();
    }

    /**
     * A bit of a hack to show only the top most popup dialog (i.e. hide dialogs lower in the stack)
     * Could not find a way to do this via the component itself, so manipulating the DOM directly to
     * hide lower level dialogs.
     */
    showTopMostPopupOnly() {
        Array.from(document.querySelectorAll('.cdk-overlay-container .cdk-global-overlay-wrapper'))
            .forEach((node, index, array) => {
                if (index !== array.length - 1) {
                    (<HTMLElement>node).style.display = 'none';
                    (<HTMLElement>node.previousElementSibling).style.display = 'none';
                } else {
                    (<HTMLElement>node).style.display = '';
                    (<HTMLElement>node.previousElementSibling).style.display = '';
                }
            });
    }

    getGroupTypeName(id: number) {
        return this.groupTypes.find(gType => gType.group_type_id === (id || 1)).group_type;
    }

    openPopup(event: any) {
        const memberType = (event.member_type ? event.member_type : (event.recipient_type ? event.recipient_type : null));
        switch (memberType) {
            case 'INDIVIDUAL':
                this.openIndividualPopup((event.member_type ? event.member_id : (event.recipient_type ? event.recipient_id : null)));
                break;
            case 'DEVICE':
                this.openDevicePopup((event.member_type ? event.member_id : (event.recipient_type ? event.recipient_id : null)));
                break;
            case 'GROUP':
                this.openGroupPopup((event.member_type ? event.member_id : (event.recipient_type ? event.recipient_id : null)));
                break;
            default:
                if (event.full_name != undefined) {
                    this.openIndividualPopup(event.id);
                } else {
                    let popupOpened = false;
                    this.individualsService.getIndividuals(event).subscribe({
                        next: individuals => {
                            const individuals2 = individuals.filter(individual => individual.full_name === event);
                            if (individuals2.length === 1) {
                                this.openIndividualPopup(individuals2[0].id);
                                popupOpened = true;
                            } else {
                                this.groupsService.getGroupNames(event).subscribe({
                                    next: groups => {
                                        groups = groups.filter(group => group.name === event);
                                        if (groups.length === 1) {
                                            this.openGroupPopup(groups[0].id);
                                            popupOpened = true;
                                        } else {
                                            this.deviceService.getDevicesByName(event).subscribe({
                                                next: devices => {
                                                    devices = devices.filter(device => device.name === event);
                                                    if (devices.length === 1) {
                                                        this.openDevicePopup(devices[0].id);
                                                        popupOpened = true;
                                                    }
                                                    if (!popupOpened) {
                                                        this.snackbarService.openSnackBar('Individual/Channel/Group Not Found', true);
                                                    }
                                                }, error: () => this.snackbarService.openSnackBar('Error fetching channel', true)
                                            });
                                        }
                                    }, error: () => this.snackbarService.openSnackBar('Error fetching group', true)
                                });
                            }
                        }, error: () => this.snackbarService.openSnackBar('Error fetching individual', true)
                    });
                }
                break;
        }
    }

    openDevicePopup(deviceID: any) {
        this.deviceService.getDevice(deviceID).subscribe((device: Device) => {
            const popupDialog = this.dialog.open(ChipPopupComponent, {
                width: '55%',
                maxHeight: '90vh',
                data: {object: device, type: 'DEVICE'}
            });

            popupDialog.beforeClosed().subscribe(res => this.dialogCloseAll(res));
        });
    }

    openIndividualPopup(indID: any) {
        this.individualsService.getIndividual(indID).subscribe((individual: Individual) => {
            const popupDialog = this.dialog.open(ChipPopupComponent, {
                width: '65%',
                maxHeight: '90vh',
                data: {object: individual, type: 'INDIVIDUAL'}
            });

            popupDialog.beforeClosed().subscribe(res => this.dialogCloseAll(res));
        });
    }

    openGroupPopup(groupID: any) {
        this.groupsService.getGroup(groupID).subscribe((group: Group) => {
            const popupDialog = this.dialog.open(ChipPopupComponent, {
                width: '85%',
                maxHeight: '90vh',
                data: {object: group, type: 'GROUP'}
            });

            popupDialog.beforeClosed().subscribe(res => this.dialogCloseAll(res));
        });
    }

    updateContactMessageTypesChips(contacts: Contact[]) {
        this.responseRequiredContacts = [];
        this.responseRequiredAndInfoContacts = [];
        this.informationalContacts = [];
        this.silencedContacts = [];

        if (contacts) {
            contacts.forEach(contact => {
                switch (contact.message_type) {
                    case 'RESPONSE_REQUIRED':
                        this.responseRequiredContacts.push(contact);
                        break;
                    case 'RESPONSE_REQUIRED_AND_INFORMATIONAL':
                        this.responseRequiredAndInfoContacts.push(contact);
                        break;
                    case 'INFORMATIONAL':
                        this.informationalContacts.push(contact);
                        break;
                    case 'NONE':
                        this.silencedContacts.push(contact);
                }
            });
        }
    }

    dialogCloseAll(bool: boolean) {
        if (bool) {
            this.dialog.closeAll();
        }
    }


    @HostListener('window:resize', ['$event'])
    onResize() {
        this.isMobileResolution = window.innerWidth < 768;
    }

    getContactType(contact) {
        return contact.contact_type.toUpperCase();
    }

    load(page) {
        if (page.data === undefined) {
            this.pageNum = page;
            this.dataService.getIndividualAndAssociateNamesPage(this.filter, page * 15).subscribe((names: Pageable<Individual>) => {
                this.associateNames = names.content;
                this.associateNamesFormatted = [];
                this.associateNames.forEach(e => this.associateNamesFormatted.push((e.id ? ' ' : '⚠️ ') + `${e.full_name} (${e.external_id})`));
            });
        }
    }

    escalateTo() {
        return this.object.escalate_to !== 'Do Not Escalate';
    }
}
